/* eslint-disable import/no-cycle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import graphReactor from '@/graphReactor';
import highway from '@/plugins/highway';
import eventToEventStore from '../plugins/eventToEventStore';
import asyncForeach from '../plugins/async-foreach';
import sleep from '../plugins/sleep';
// import root from vue from
// eslint-disable-next-line

export default {
  // Action to send information to Event Store
  async eventToEventStore({ commit, getters }, {
    actor, verb, value, dataSource,
  }) {
    const actorToSend = actor || {
      ...getters.getUserInfo,
    };
    const toSend = {
      actor: actorToSend,
      verb,
      value,
      dataSource,
    };
    toSend.dataSource = 'tj-client-web';
    console.log({ toSend });
    await axios.post(`${process.env.VUE_APP_ZELDA_URI}/event`, toSend);
    commit('SET_EVENT_TO_EVENT_STORE', toSend);
  },

  fetchBooks({ state, commit }) {
    return new Promise((resolve) => {
      axios
        .get(`${process.env.VUE_APP_AXIOS_URI}/book`)
        .then((res) => {
          console.log(`Books : ${JSON.stringify(res.data)}`);
          commit('setBooks', res.data);
          resolve(state.books);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },

  fetchWidgetName({ commit }, value) {
    return new Promise((resolve) => {
      if (value) {
        commit('setWidgetName', value);
        resolve(value);
      } else {
        resolve(null);
      }
    });
  },

  async wikiWordFetch({ commit, state, dispatch }, wikiWord) {
    const loader = await dispatch('startLoader', {
      event: 'Wikipedia Lookup',
      message: wikiWord,
    });

    commit('setWikiWord', wikiWord);
    // First request without image
    const wikiInformation = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/wikidata`, {
      word: wikiWord,
      images: false,
      videos: false,
    });

    commit('setWikiInformation', wikiInformation.data);
    // second with images
    const wikiInformation2 = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/wikidata`, {
      word: wikiWord,
      images: true,
      videos: false,
    });

    commit('setWikiInformation', wikiInformation2.data);
    const currentDate = new Date().getTime();

    const action = {
      searchEntity: state.wikiWord,
      result: state.wikiInformation,
      timeStamp: {
        machineReadable: currentDate,
        humanReadable: moment(currentDate).format('MMMM Do YYYY, h:mm:ss a'),
      },
    };

    const relation = {
      verb: 'WIKI_LOOKUP',
    };

    const entity = {

      ...relation,
      value: action,
    };

    dispatch('eventToEventStore', entity);
    dispatch('endLoader', loader);
  },

  async dictWordPopUp({ dispatch }, dictPopUpWord) {
    const wikiInformation = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/dictionary-api`, {
      params: {
        word: dictPopUpWord,
      },
    });
    dispatch('eventToEventStore', {
      verb: 'QUICK_SEARCH',
      value: dictPopUpWord,
    });
    return wikiInformation.data;
  },

  async fetchAllGraph({ commit, dispatch, state }, payload) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/g6graph`, {
      params: {
        ...(payload.user === '@me' && { username: state.auth.user.username }),
      },
    });
    dispatch('eventToEventStore', {
      verb: 'GRAPH_LIBRARY',
      value: payload,
    });
    commit('SET_ALL_GRAPH_LIST', response.data);
  },

  async fetchGraphByTag({ commit }, tagId) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/g6graph/tag/${tagId}`);
    commit('SET_ALL_GRAPH_LIST', response.data);
  },

  toggleGroupMode({ commit }, booleanVal) {
    commit('SET_GROUP_MODE', booleanVal);
  },

  async setEditMode({ commit }, payload) {
    commit('SET_EDIT_MODE', payload);
  },

  async fetchExploreDescription({ commit }, exploreEntity) {
    const exploreResponseObj = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/explore/description`, {
      query: exploreEntity,
    });
    const descripiton = await exploreResponseObj.data.extract;
    console.log(descripiton);
    commit('SET_EXPLORE_DESCRIPTION', descripiton);
  },

  async getDescription({ commit }, exploreEntity) {
    const getDescription = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/explore/description`, {
      query: exploreEntity,
    });
    const descripiton = await getDescription.data.extract;
    console.log(commit);
    return descripiton;
  },

  async fetchTagContent({ commit }, name) {
    const res = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/tag/${name}`);
    commit('SET_TAG_CONTENT', res.data);
  },

  async fetchExploreInformation({ commit }, exploreEntity) {
    // const loader = await dispatch('startLoader', {
    //   event: 'Exploring',
    //   message: exploreEntity,
    // });
    console.log('I AM WORKING...');
    const exploreResponseObj = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/explore/links`, {
      query: exploreEntity,
    });
    console.log(exploreResponseObj);

    // const exploreObj = {
    //   entity: exploreEntity,
    //   links: exploreResponseObj.data.links,
    // };
    console.log(commit);
    return exploreResponseObj.data.links;
    // commit('setExploreInformation', exploreObj);
    // dispatch('endLoader', loader);
  },

  async graphDumpFetch({ commit, dispatch }) {
    const loader = await dispatch('startLoader', {
      event: 'Fetching Knowledge Graph',
      message: 'Neo4j',
    });
    const graphRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/query/json`);
    console.log(JSON.stringify(graphRaw));
    const forceGraph = graphRaw.data;

    commit('setVisitedGraph', forceGraph);
    dispatch('endLoader', loader);
  },
  setRangeValue({ commit }, rangeValue) {
    commit('setRangeValue', rangeValue);
  },
  setEdgeValue({ commit }, val) {
    commit('setEdgeValue', val);
  },
  setActiveLayoutKey({ commit }, layoutKey) {
    commit('setActiveLayoutKeyMut', layoutKey);
  },
  async activateLayout({ commit, state }, payload) {
    const latestLayout = state.layout;
    if (latestLayout.layout_tabs[payload.layoutKey].includes(payload.componentName)) {
      const getIndexOfLayout = latestLayout.layout_tabs[payload.layoutKey].indexOf(payload.componentName);
      latestLayout.layout_tab_selection[payload.layoutKey] = getIndexOfLayout;
    } else {
      const changeLayouSelectionD = [...latestLayout.layout_tabs[payload.layoutKey], payload.componentName];
      latestLayout.layout_tabs[payload.layoutKey] = changeLayouSelectionD;
      const getIndexOfLayout = latestLayout.layout_tabs[payload.layoutKey].indexOf(payload.componentName);
      latestLayout.layout_tab_selection[payload.layoutKey] = getIndexOfLayout;
    }
    commit('SET_ACTIVATE_LAYOUT', latestLayout);
  },

  setNodeLabel({ commit }, nodeLabel) {
    commit('SET_NODE_LABEL', nodeLabel);
  },

  setEdgeLabel({ commit }, edgeLabel) {
    commit('SET_EDGE_LABEL', edgeLabel);
  },

  setEdgeStrength({ commit }, edgeStrength) {
    commit('SET_EDGE_STRENGTH', edgeStrength);
  },

  async graphVisitedDumpFetch({ commit, dispatch }) {
    const loader = await dispatch('startLoader', {
      event: 'Fetching Knowledge Graph',
      message: 'Neo4j',
    });
    const graphRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/query/json_mongo`);
    console.log(JSON.stringify(graphRaw));
    const forceGraph = graphRaw.data;

    commit('setVisitedGraph', forceGraph);
    dispatch('endLoader', loader);
  },

  fetchVerb({ commit }, verb) {
    commit('setVerb', verb);
    return new Promise((resolve) => {
      resolve(verb);
    });
  },

  toggleSidebar({ commit }) {
    commit('toggleSidebar');
  },

  updateGraphSetting({ commit }, filters) {
    commit('SET_FG_COMPONENT_SETTING', {
      nodeFilter: filters.nodeFilter,
      edgeFilter: filters.edgeFilter,
    });
  },

  setSelectedNode({ commit }, selectedNode) {
    commit('SET_SELECTED_NODE', selectedNode);
  },

  clearMetaSelection({ commit }) {
    commit('CLEAR_META_SELECTION');
  },

  async askWolfram({ commit, dispatch }, question) {
    const loader = await dispatch('startLoader', {
      event: 'Asking Wolfram Engine',
      message: question,
    });

    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/askwolfram`, {
      params: {
        question,
      },
    });
    const answer = response.data.ans;
    commit('ASK_WOLFRAM', {
      question,
      answer,
    });
    dispatch('endLoader', loader);
  },

  showNotification({ commit }) {
    commit('SHOW_NOTIFICATION');
  },

  hideNotification({ commit }) {
    commit('HIDE_NOTIFICATION');
  },

  async mostSearchedWord({ dispatch, state }, payload) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/search/count`, {
      params: {
        timestamp: payload.date,
        ...(payload.user === '@me' && { username: state.auth.user.username }),
      },
    });
    dispatch('eventToEventStore', {

      verb: 'MOST_SEARCH_FILTER',
      value: {
        date: payload.date,
      },
    });
    return response.data.count;
  },

  async pieChartDump({ commit, state }) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/count`, {
      params: {
        username: state.auth.user.username,
      },
    });

    const pieDump = response.data;
    const pieData = pieDump.verbs.map((item) => ({
      type: item.verb,
      value: parseFloat(((item.count / pieDump.count) * 100).toFixed(2)),
    }));
    commit('SET_PIE_DATA', pieData);
  },

  async setRouteDetail({ commit }, routeDetail) {
    commit('SET_ROUTE_INFO', routeDetail);
  },

  async eventsDumpFetch({ commit, dispatch }) {
    const loader = await dispatch('startLoader', {
      event: 'Pulling TJ Event log',
      message: 'All activities',
    });

    const eventsRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/lastndays/1`);
    console.log({ eventsRaw });
    commit('SET_EVENTS_RAW_LOG', eventsRaw);

    dispatch('endLoader', loader);
  },
  async eventsBuckedFetch({ commit, dispatch }) {
    const loader = await dispatch('startLoader', {
      event: 'Pulling TJ Events Sky View',
      message: 'All activities',
    });

    const eventsRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/eventsbucket`);
    console.log({ eventsRaw });
    commit('SET_EVENTS_BUCKET_LOG', eventsRaw);

    dispatch('endLoader', loader);
  },

  async eventsVerbFetch({ commit, dispatch }, verb) {
    const loader = await dispatch('startLoader', {
      event: `Pulling TJ ${verb}-Event logs `,
      message: verb,
    });

    const eventsRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/verb/${verb}`);

    commit('SET_EVENTS_VERB', eventsRaw);

    dispatch('endLoader', loader);
  },

  async notesFetch({ commit, state }, payload) {
    if (payload.type === 'next') {
      const eventsRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/notes`, {
        params: {
          pageNo: payload.pageNo,
          ...(payload.user === '@me' && { username: state.auth.user.username }),
        },
      });

      console.log('notesFetch', eventsRaw.data);
      commit('SET_NOTES', eventsRaw);
    } else if (payload.type === 'search') {
      const eventsRaw = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/notes`, {
        params: {
          pageNo: payload.pageNo,
          searchWord: payload.searchWord,
        },
      });

      console.log('notesFetch', eventsRaw.data);
      commit('SET_NOTES', eventsRaw);
    }
  },

  async deleteNote({ dispatch }, note) {
    const deleteNote = await axios.delete(`${process.env.VUE_APP_AXIOS_URI}/notes/${note._id}`);
    console.log({ deleteNote });
    await dispatch('eventToEventStore', {
      verb: 'DELETE_NOTE',
      value: {
        id: note._id,
      },
    });
    // commit('DELETE_NOTE', deleteNote);
    // dispatch('endLoader', loader);
    // dispatch('eventsVerbFetch', note.verb);
  },

  startLoader({ commit }, payload) {
    const id = uuidv4();
    commit('START_LOADER', {
      id,
      payload,
    });
    return id;
  },

  endLoader({ commit }, id) {
    commit('END_LOADER', id);
  },

  async saveStateToSnaphot({ state }, recordingData) {
    const { user } = state.auth;
    const { mutationSeries } = recordingData;
    const { startingState } = recordingData;
    console.log(state);
    console.log({ startingState, mutationSeries });
    const saved = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/states`, {
      actor: user,
      state: startingState,
      mutationSeries,
    });
    router.push({
      name: 'Thought',
      params: { id: saved.data.id },
    });
  },

  async saveCurrentGraph({ dispatch, commit, state }, payload) {
    console.log('saveCurrentGraph', payload);
    const saved = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/g6graph`, {
      actor: state.auth.user,
      g6_data: {
        graph_name: payload.graph_name,
        gdata: payload.gdata,
        graph_type: payload.graph_type,
      },
      tags: payload.graph_tags,
    });
    commit('SET_SAVED_GRAPH', saved.data);
    dispatch('eventToEventStore', {
      verb: 'GRAPHED',
      value: {
        // eslint-disable-next-line
        graphId: saved.data._id,
      },
    });
  },

  async FetchVisitedByUser({ state }) {
    const linkVisited = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/verb`, {
      params: {
        verb: 'VISITED',
        username: state.auth.user.username,
      },
    });

    console.log({ linkVisited });

    return linkVisited.data;
  },

  async getSavedTjState({ commit, dispatch }, id) {
    const savedState = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/states/${id}`);
    commit('SET_SAVED_TJ_STATE', savedState.data.state);
    console.log(savedState.data.mutationSeries);
    console.log(savedState.data.state);

    if (savedState.data.mutationSeries && savedState.data.mutationSeries.length > 0) {
      dispatch('setMutationSeries', savedState.data.mutationSeries);
    }
    // dispatch('replayMutationSeries', savedState.data.mutationSeries);
  },
  setCurrentBook({ commit, dispatch }, book) {
    commit('SET_CURRENT_BOOK', book);

    const currentDate = new Date().getTime();
    const action = {
      book,
      timeStamp: {
        machineReadable: currentDate,
        humanReadable: moment(currentDate).format('MMMM Do YYYY, h:mm:ss a'),
      },
    };

    dispatch('eventToEventStore', {
      verb: 'BOOK_CHECKOUT',
      value: action,
    });
  },

  clearCurrentBook({ commit }) {
    commit('CLEAR_CURRENT_BOOK');
  },

  startThoughtRecord({ state }) {
    console.log('Starting to record');

    state.graph.nodes = [];
    state.graph.links = [];
    state.eventsRaw = [];
    state.eventsVerb = [];
    state.explore.graphData = [];
    console.log(state);
    const startingState = JSON.parse(JSON.stringify(state));
    return startingState;
  },

  async endThoughtRecord({ dispatch }, recordingData) {
    dispatch('saveStateToSnaphot', recordingData);
  },

  async replayMutationSeries({ commit }, mutationSeries) {
    await asyncForeach(mutationSeries, async (mutationSnap, i) => {
      commit(mutationSnap.mutation.type, mutationSnap.mutation.payload);
      console.log(`REPLAY | Mutation#${i} : ${mutationSnap.mutation.type}`);
      console.log(mutationSnap.mutation.payload);
      await sleep(mutationSnap.timeDeltaMillis);
    });
  },

  async setMutationSeries({ commit }, mutationSeries) {
    commit('SET_MUTATIONSERIES', mutationSeries);
  },

  async updateWidgetSettings({ commit, dispatch }, widgetSettings) {
    commit('SET_WIDGET_SETTINGS', widgetSettings);
    await dispatch('upsertSettingsToServer');
  },

  async updateSocialSettings({ commit, dispatch }, socialSettings) {
    commit('SET_SOCIAL_SETTINGS', socialSettings);
    await dispatch('upsertSettingsToServer');
  },

  async upsertSettingsToServer({ state }) {
    if (state.userInfo) {
      const { user } = state.auth;
      const { settings } = state;
      const saved = await axios.put(`${process.env.VUE_APP_AXIOS_URI}/userProfiles/${user.discriminator}`, {
        actor: user,
        settings,
      });
      console.log(saved);
      return saved;
    }
    return null;
  },

  async getUserSettingsFromServer({ commit, state }) {
    if (state.userInfo) {
      const { user } = state.auth;
      const savedSetting = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/userProfiles/${user.discriminator}`);
      commit('SET_WIDGET_SETTINGS', savedSetting.data.settings.widget);
      commit('SET_SOCIAL_SETTINGS', savedSetting.data.settings.widget);
    }
  },

  async fetchThreeDModel({ commit }, searchTerm) {
    const AccessToken = process.env.VUE_APP_SKETCHFAB_TOKEN;
    let { data } = await axios.get(
      `https://api.sketchfab.com/v3/search?type=models&q=${searchTerm}`,
      {
        headers: {
          Authorization: `token ${AccessToken}`,
        },
      },
    );
    if (data.results.length === 0) {
      data = {
        results: [{ uid: '26d35013a100480da708852ed8d06651' }],
      };
    }
    commit('SET_THREEDMODELDATA', data);
  },
  async autoCompleteSuggestion({ commit }, searchTerm) {
    const response = await axios.get(`https://api.datamuse.com/sug?&v=enwiki&s=${searchTerm}`);
    const suggestionList = response.data.map((item) => item.word);
    commit('SET_AUTOCOMPLETE_SUGGESTIONS', suggestionList);
  },
  async suggestions({ commit }, chosen) {
    let data = [];
    const Token = process.env.VUE_APP_SUGGESTION_TOKEN;
    const options = {
      method: 'POST',
      url: 'https://jspell-checker.p.rapidapi.com/check',
      headers: {
        'content-type': 'application/json',
        'x-rapidapi-key': `${Token}`,
        'x-rapidapi-host': 'jspell-checker.p.rapidapi.com',
      },
      data: {
        language: 'enUS',
        fieldvalues: chosen,
        config: {
          forceUpperCase: false,
          ignoreIrregularCaps: false,
          ignoreFirstCaps: true,
          ignoreNumbers: true,
          ignoreUpper: false,
          ignoreDouble: false,
          ignoreWordsWithNumbers: true,
        },
      },
    };
    axios.request(options).then((response) => {
      // console.log(response.data);
      data = response.data.elements[0].errors[0].suggestions;
      console.log(data);
      commit('SET_SUGGESTIONDATA', data);
    }).catch((error) => {
      console.error(error);
      return error;
    });

    // console.log({ data });
  },

  async entityCollector({ state }, noteData) {
    const data = {
      sentence: noteData,
      user: state.auth.user,
    };
    axios.post(`${process.env.VUE_APP_NEOSTG}/entity-collector`, data).then((res) => {
      console.log('Extracted Info:-', res.data);
    });
  },

  // eslint-disable-next-line no-unused-vars
  async getNote({ commit }, id) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/notes/${id}`);
    commit('singleNote', response.data);
  },

  async addToNote({ dispatch }, data) {
    console.log({ ...data });
    const response = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/notes`, data);
    console.log(response.data);
    await dispatch('eventToEventStore', {
      verb: 'NOTED',
      value: {
        note: response.data,
      },
    });
  },

  async updateDetailPayload({ commit }, payload) {
    commit('SET_PAYLOAD_DETAIL', payload);
  },

  // ? focus the selected Item based on the type
  async focusCurrentItem({ dispatch, state, commit }, payload) {
    graphReactor.exploreInstance
      .findAllByState(`${payload.type}`, 'focusEd')
      .forEach((item) => {
        graphReactor.exploreInstance.clearItemStates(item, 'focusEd');
      });
    graphReactor.exploreInstance.focusItem(payload.id);
    graphReactor.exploreInstance.setItemState(payload.id, 'focusEd', true);
    if (payload.state.isActiveDetail === 'Nodes') {
      const ModelData = graphReactor.exploreInstance.findById(payload.id);
      const Model = ModelData.getModel();
      const nodePayload = { content: Model, formDataObj: Model };
      commit('SET_PAYLOAD_DETAIL', nodePayload);
      highway.excludeDispatcher(payload.id, ['gmodule/exploreGraphFetch']);
      console.log('EDVANTA INDEX', payload.id);
      await dispatch('youtubeSearchByKeyword', payload.id);
      if (state.edit_mode === 'explore') {
        // Highway.singleDispatcher('youtubeSearchByKeyword');
        const wordObj = {
          word: payload.id,
          label: payload.id,
          type: 'string',
          lang: 'en',
        };
        // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
        await dispatch('setCurrentThought', wordObj);
      }
    }
  },

  async gutenBergBooks({ commit }) {
    const books = await axios.get('https://gutendex.com/books');
    commit('SET_GUT_BOOKS', books.data.results);
  },

  async gutenBergBook({ commit }, id) {
    const book = await axios.get(`https://gutendex.com/books/${id}`);
    commit('SET_GUT_BOOK', book.data);
  },

  async comapreDetailAction({ commit, dispatch }, wordDetail) {
    const response1 = await axios.get(`https://thoughtjumper.edvanta.com/api/v1/custom/snippet?word=${wordDetail.word1}&type=word`);
    const response2 = await axios.get(`https://thoughtjumper.edvanta.com/api/v1/custom/snippet?word=${wordDetail.word2}&type=word`);
    const word1Result = await response1.data.response;
    const word2Result = await response2.data.response;
    // eslint-disable-next-line
    const commonKeys = Object.keys(word1Result).filter((key) => word2Result.hasOwnProperty(key));
    const commonValues = commonKeys.map((key) => {
      if (key === 'name' || key === 'description') {
        return {
          key,
          label: key,
          value1: { value: word1Result[key], type: 'text' },
          value2: { value: word2Result[key], type: 'text' },
        };
      }
      return {
        key,
        label: word1Result[key].label,
        value1: word1Result[key].value,
        value2: word2Result[key].value,
      };
    });
    commit('SET_COMPARE_DETAIL', commonValues);
    dispatch('eventToEventStore', {
      verb: 'COMPARE',
      value: {
        word1: wordDetail.word1,
        word2: wordDetail.word2,
      },
    });
  },

  async wikiSnippet({ commit }, paramsObj) {
    const { data } = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/snippet`, {
      params: paramsObj,
    });
    console.log(data);
    commit('SET_WIKI_SNIPPET', data.response);
  },

  updateLayoutSettings({ commit }, layoutSettings) {
    commit('SET_LAYOUT_SETTINGS', JSON.parse(JSON.stringify(layoutSettings)));
  },

  editLayout({ commit }) {
    commit('EDIT_LAYOUT');
  },

  resizeLayout({ commit }) {
    commit('RESIZE_LAYOUT');
  },

  changeLocale({ commit }, locale) {
    localStorage.setItem('locale', locale);
    commit('SET_LOCALE', locale);
  },

  async mostSearchedWordList({ commit }) {
    const res = await axios.post(
      `${process.env.VUE_APP_AXIOS_URI}/query`,
      {
        query:
          'MATCH ()-[]->(a:Word) WITH a.word AS Word, count(()-[]->(a)) AS count RETURN Word, count ORDER BY count DESC',
      },
    );
    // eslint-disable-next-line
    const data = res.data.map((item) => ({ word: item._fields[0], detail: item._fields[1] }));
    commit('SET_MOST_SEARCHED_WORDS', data);
  },

  async compareListAction({ commit }) {
    const res = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/events/verb/COMPARE_LIST`);
    const userData = res.data.filter((item) => item.actor.username === this.state.auth.user.username);
    const comapreList = userData.map((item) => {
      const data = {
        id: item.id,
        word: item.value.word,
      };
      return data;
    });
    commit('SET_COMPARE_LIST', comapreList);
  },

  async wikiGraphAction({ commit, state }, wordObj) {
    const res = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/entity-cluster`, {
      params: {
        word: wordObj.word,
        type: wordObj.type,
        lang: wordObj.lang,
      },
    });
    console.log(res.data);
    commit('SET_GRAPH_EXPANSION', res.data);
    commit('setGraph', {
      nodes: state.g6_graph_data.nodes.map((item) => ({
        ...item,
      })),
      links: state.g6_graph_data.edges.map((item) => ({
        ...item,
      })),
    });
  },

  async dendroGraphAction({ commit }, wordObj) {
    const res = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/snippet/graph`, {
      params: {
        word: wordObj.word,
        type: wordObj.type,
        lang: wordObj.lang,
      },
    });
    console.log(res.data);
    console.log(wordObj);
    const mainNode = res.data.nodes[0];
    mainNode.custom_id = mainNode.id;
    mainNode.children = res.data.nodes.slice(1, 20).map((el) => ({ ...el, custom_id: el.id }));
    const dendroEdges = res.data.edges.reduce((acc, item) => {
      if (!acc.hasOwnProperty(`${item.source}${item.target}`)) {
        acc[`${item.source}${item.target}`] = item.label;
      }
      return acc;
    }, {});
    console.log('dendroEdges Q29647346Q53094', dendroEdges.Q29647346Q53094);
    commit('SET_DENDRO_EDGES', dendroEdges);

    commit('SET_DENDRO_DATA', mainNode);
  },

  // eslint-disable-next-line
  async fetchAndSetDendroExpansion({ state, commit }, payload) {
    const dendroEdges = payload.edges.reduce((acc, item) => {
      if (!acc.hasOwnProperty(`${item.source}${item.target}`)) {
        acc[`${item.source}${item.target}`] = item.label;
      }
      return acc;
    }, {});
    console.log('dendroEdges Q29647346Q53094', dendroEdges.Q29647346Q53094);
    commit('SET_DENDRO_EDGES', dendroEdges);
  },

  async setDendroData({ commit }, data) {
    commit('SET_DENDRO_DATA', data);
  },
  // eslint-disable-next-line no-unused-vars
  async uploadToAWS({ commit, dispatch, state }, blobData) {
    // upload the screen recording to AWS S3
    const fd = new FormData();
    fd.append('upl', blobData, 'blobby.mp4');
    const response = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/scr/upload`, fd);
    const uploadObj = await response.data;
    const url = uploadObj.Location;

    // upload the caption file related to the recording to the server
    const captionResponse = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/scr/uploadvtt`, {
      sentences: state.screenRecordCaption,
      actor: state.auth.user,
      timeStamp: new Date().toISOString(),
    });

    const captionUrl = captionResponse.data.Location;

    const screenRecordState = {
      url,
      captionUrl,
    };
    commit('SET_SCREEN_RECORD_STATE', screenRecordState);

    const value = {
      note: url,
      NoteUrl: url,
      captionUrl: captionUrl || '',
      type: 'recording',
      timestamp: moment().format(),
    };

    const verb = 'NOTED';
    const actor = state.auth.user;

    const data = {
      actor,
      verb,
      value,
      dataSource: 'tj-client',
    };
    dispatch('addToNote', data);

    // empty the screen record caption after adding to note
    dispatch('SET_SCREEN_RECORD_CAPTION', []);

    // return a promise for synchronous use
    return new Promise((resolve) => {
      resolve(data);
    });
  },

  setUploadingG6Data({ commit }) {
    commit('SET_UPLOADING_G6_DATA');
  },

  screenRecordCaption({ commit }, data) {
    commit('SET_SCREEN_RECORD_CAPTION', data);
    return new Promise((resolve) => {
      resolve(data);
    });
  },

  async graphExpansion({ state, commit }, wordObj) {
    const res = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/entity-cluster`, {
      params: {
        word: wordObj.word,
        type: wordObj.type,
        lang: wordObj.lang,
      },
    });
    console.log(res.data);
    commit('SET_GRAPH_EXPANSION', res.data);
    commit('setGraph', {
      nodes: state.g6_graph_data.nodes,
      links: state.g6_graph_data.edges,
    });
  },

  async xapiEvent({ dispatch }, event) {
    const firstStatement = event.statement;
    console.log({ firstStatement });
    if (firstStatement) {
      /* eslint-disable */

      const object = firstStatement.object;
      object.definition.extensions = '';

      dispatch('eventToEventStore', {
        verb: firstStatement.verb,
        value: {
          object,
        },
      });
    }
  },
  async getLatestAutoMarkdown({ commit, state }) {
    if (state.userInfo) {
      const user = state.auth.user;
      const thoughtMarkdown = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/query/userMarkdown`, {
        params: {
          actor: user,
        },
      });
      commit('FETCH_AUTO_MARKDOWN', thoughtMarkdown.data);
      console.log({ thoughtMarkdown });
    }

  },

  async twitterDetails({ state }, twitterObj) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/custom/twitter-sentiment`, {
      params: {
        topic: twitterObj.topic,
        count: twitterObj.count,
      },
    });
    state.twitter_data = response.data.twitter;
  },
  toggleCameraStatus({ commit }) {
    commit('TOGGLE_CAMERA_STATUS');
  },

  async updateNoteDispatch({ dispatch, state, commit }, noteObj) {
    // console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss',noteObj);
    const response = await axios.put(`${process.env.VUE_APP_AXIOS_URI}/notes/update/${noteObj.id}`, {
      note: noteObj.note,
      type: noteObj.type,
    });
    await dispatch('eventToEventStore', {
      verb: 'UPDATE_NOTE',
      value: {
        id: noteObj.id,
      },
    });
  },

  async getListOfAllQuests({ commit, getters }) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/quests`, {
      headers: getters.getUserAccessToken ?
        {
          'Authorization': `Bearer ${getters.getUserAccessToken}`,
        } : {},
    });
    commit('SET_ALL_QUESTS', response.data);
  },
  async updateQuestWithGraph({ commit, state }, questObj) {
    const response = await axios.put(`${process.env.VUE_APP_AXIOS_URI}/quests/${state.current_quest_id}`, {
      thought_map: questObj,
    });
    console.log({
      questUpdateResponse: response.data,
    });
  },
  async saveAsQuest({ state, dispatch, commit }) {
    let toStoreNav = state.nav_data;
    toStoreNav.edges = state.nav_data.edges.map((el) => ({
      source: el.source,
      target: el.target,
    }));
    const response = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/quests`, {
      general_information: [{
        title: (state.auth.user?.username || 'open') + '_' + new Date().toISOString(),
      }],
      thought_map: toStoreNav,
    });
    const questID = response.data.id;
    dispatch('getListOfAllQuests');
    commit('SET_CURRENT_QUEST', questID);
  },
  async saveToCurrentQuest({ state, dispatch }) {
    let toStoreNav = state.nav_data;
    toStoreNav.edges = state.nav_data.edges.map((el) => ({
      source: el.source,
      target: el.target,
    }));
    dispatch('updateQuestWithGraph', toStoreNav);
  },

  async loadFromCurrentQuest({ commit, state, dispatch }) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/quests/${state.current_quest_id}`);
    dispatch('cleanSelectedEntity');
    commit('SET_NAV_DATA', response.data.thought_map);
    setTimeout(() => {
      dispatch('setFirstNodeAsCurrentFromQuest');
    }, 1000);
  },

  async setFirstNodeAsCurrentFromQuest({ dispatch, getters }) {
    let availableNodes = getters.getAvailableThoughtNodes;
    if (availableNodes && availableNodes.length > 0) {
      let switchToNode = availableNodes[0];
      const wordObj = {
        word: switchToNode.label, label: switchToNode.label, type: 'string', lang: 'en',
      };
      dispatch('setCurrentThought', wordObj, true);
    }
  },

  setCurrentQuest({ commit, dispatch }, questID) {
    commit('SET_CURRENT_QUEST', questID);
    dispatch('loadFromCurrentQuest');
  },

  async deleteMyQuest({ state }, questID) {
    const response = await axios.delete(`${process.env.VUE_APP_AXIOS_URI}/quests/${questID}`);
    const entity = {
      verb: 'DELETED_QUEST',
      value: {
        // eslint-disable-next-line
        questId: response.data._id,
      },
    }
    eventToEventStore(entity);
  },

  setCurrentThought({ state, commit, dispatch, getters }, thoughtObject, isReplay = false) {
    if (getters.compareWithCurrentThought(thoughtObject) === true) {
      console.log('Same word searched, hence propergation stopped');
      return
    }
    switch (thoughtObject.type) {
      case 'string':
        // Example
        // {
        //   "word": "hello",
        //   "label": "hello",
        //   "type": "string",
        //   "lang": "en"
        // }
        dispatch('setCurrentEntity', thoughtObject);
        break;
      case 'entity':
        // Example
        // {
        //   "qid": "Q415",
        //   "label": "hello",
        //   "type": "string",
        //   "lang": "en"
        // }
        dispatch('setCurrentEntity', thoughtObject);
        break;
      case 'note':
        // Example
        // {
        //    noteId: 'uniqueId as external Identifier',
        //    label: 'Custom Label(optional)',
        //    type: 'note',
        //  }

        dispatch('setCurrentNote', thoughtObject);
        // dispatch('loadEntityFromNote', thoughtObject);
        break;
      case 'graph':
        // Example
        // {
        //    graphId: 'uniqueId as external Identifier',
        //    label: 'Custom Label(optional)',
        //    type: 'graph',
        //  }
        dispatch('SET_CURRENT_GRAPH', thoughtObject.graphId);
        // dispatch('loadEntityFromGraph', thoughtObject);
        break;
      case 'quest':
        // Example
        // {
        //    questId: 'uniqueId as external Identifier',
        //    label: 'Custom Label(optional)',
        //    type: 'quest',
        //  }
        dispatch('setCurrentQuest', thoughtObject.questId);

      default:
        console.log('Invalid Thought Type');
        break;
    }

    const lastSelectedThought = state.current_thought;
    commit('SET_CURRENT_THOUGHT', thoughtObject);
    const currentThoughtPos = getters.getCurrentThoughtPositionInThoughtMap;
    if (currentThoughtPos !== -1) {  // This means Thought is already in the thought map
      dispatch('updateLayoutFromThoughtMap', thoughtObject.label);
    }
    // create nodes and edges fro GOC
    if (!isReplay && state.isThoughtMapRecording) {
      thoughtMapUpdationFlow({ state, commit, getters }, lastSelectedThought, thoughtObject);
    }
  },

  setCurrentEntity({ state, commit, dispatch, getters }, entityObj, isReplay = false) {
    console.log({ entityObj, current: state.current_selected_entity });
    commit('SET_CURRENT_ENTITY', entityObj);
    dispatch('eventToEventStore', {
      verb: 'SEARCHED_FOR',
      value: {
        searchEntity: entityObj.word,
      },
    })
    dispatch('searchEngine/setKeyword', entityObj.word);
  },

  async setTextToSpeech({ state, commit }, data) {
    console.log(data);
    commit('SET_TEXT_TO_SPEECH', data);
  },

  async setDescriptionMode({ state, commit }, data) {
    console.log(data);
    commit('SET_DESCRIPTION_MODE', data);
  },

  sendUpdateToThoughtMap({ state, commit, getters }) { // explicit save to ThoughtMap has been called
    const entityObj = state.current_thought;
    const lastSelectedEntity = state.last_thought;
    console.log({ entityObj, lastSelectedEntity });
    thoughtMapUpdationFlow({ state, commit, getters }, lastSelectedEntity, entityObj);
  },

  async clearThoughtMap({ commit, dispatch }) {
    commit('CLEAR_THOUGHT_MAP');
    dispatch('cleanSelectedEntity');
  },

  async replayQuest({ dispatch, state }) {
    console.log(state.nav_data.nodes);
    let nodesToReplay = state.nav_data.nodes.filter(el => el.tjtype === 'entity');
    asyncForeach(nodesToReplay, async (node) => {
      const wordObj = {
        word: node.label, label: node.label, type: 'string', lang: 'en',
      };
      dispatch('setCurrentEntity', wordObj, true);
      await sleep(1000);
    });
  },

  async toggleThoughtMapRecordingState({ state, commit }) {
    if (state.isThoughtMapRecording) {
      commit('SET_THOUGHT_MAP_RECORDING_STATE', false);
    } else {
      commit('SET_THOUGHT_MAP_RECORDING_STATE', true);
    }
  },
  async turnOffThoughtMapRecordingState({ state, commit }) {
    commit('SET_THOUGHT_MAP_RECORDING_STATE', false);
  },

  async updateLayoutFromThoughtMap({ commit, state }, entityLabel) {
    let widgets = this.getters.getWidgetsLinkedToEntityFromLabel;
    let current_layout_tabs = state.layout.layout_tabs;
    let current_layout_selection = state.layout.layout_tab_selection;
    widgets.forEach((widget) => {
      let layoutTabTarget = widget.layoutPos;
      let layoutTabIndex = current_layout_tabs[layoutTabTarget].findIndex(el => el === widget.widget);
      if (layoutTabIndex === -1) {
        current_layout_tabs[layoutTabTarget].push(widget.widget);
        layoutTabIndex = current_layout_tabs[layoutTabTarget].length - 1;
      }
      current_layout_selection[layoutTabTarget] = layoutTabIndex;
    });
    console.log({ current_layout_tabs, current_layout_selection });
    commit('SET_LAYOUT_SETTINGS', { layout: current_layout_tabs, layout_selection: current_layout_selection });
    console.log({ widgets })
  },

  async cleanSelectedEntity({ commit }) {
    commit('SET_LAST_SELECTED_ENTITY', null);
    commit('SET_CURRENT_ENTITY', null);
  },

  chooseMode({ commit }, payload) {
    commit('SET_EDIT_MODE', payload)
  },

  async youtubeSearchByKeyword({ commit }, payload) {
    console.log(payload);
    const youtubeResponse = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/youtube-search`, {
      type: 'search',
      searchObj: payload
    })
    console.log(youtubeResponse.data);
    commit('SET_YOUTUBE_SEARCH_RESULT', youtubeResponse.data);
  },

  async youtubeSearchUsingNextPage({ commit, state }) {
    if (state.youtube_search_result !== null) {
      const youtubeResponse = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/custom/youtube-search`, {
        type: 'nextPage',
        searchObj: state.youtube_search_result.nextPage
      })
      console.log(youtubeResponse.data);
      commit('SET_YOUTUBE_SEARCH_RESULT', youtubeResponse.data);
    } else {
      return true;
    }
  },
  async victoryMarkerHit({ state, dispatch }) {
    dispatch('eventToEventStore', {
      verb: 'HIT_VICTORY_MARKER',
      value: {
        currentThought: state.current_thought,
        lastThought: state.last_thought,
        questId: state.current_quest_id,
      }
    });
  },

  // Setting up global fontSize
  setGlobalFontSize({ state }, fetchObj) {
    const { fetchFromLocal, _fontSize } = fetchObj;
    if (state.auth.status.isLoggedIn) {
      const fontSize = fetchFromLocal? localStorage.getItem('font-size') || 100 : _fontSize;
      document.getElementsByTagName('html')[0].style['font-size'] = `${fontSize}%`;
      localStorage.setItem('font-size', fontSize);
    } else {
      document.getElementsByTagName('html')[0].style['font-size'] = '100%';
    }
  },

  // clean up User On Logout
  CleanUpUserOnLogout({ dispatch }) {
    dispatch('toggleSidebar', false);
    dispatch('setGlobalFontSize', {fetchFromLocal: true});
    // add here...
  },

  // set up settings for user after signup
  setUserOnLogin({ dispatch }) {
    dispatch('setGlobalFontSize', {fetchFromLocal: true});
    // add here...
  }
};

// Extra Util functions for Thought Map
function listOfWidgetsInViewNodes(state) {
  let widgetInViewIndex = state.layout.layout_tab_selection;
  let listOfWidgesNodes = [];
  Object.keys(widgetInViewIndex).forEach((layoutTab) => {

    if (!!state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]]) {
      console.log({
        id: state.current_thought.label + layoutTab + state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        widget: state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        label: state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        current_thought: state.current_thought,
      })
      listOfWidgesNodes.push({
        id: state.current_thought.label + layoutTab + state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        widget: state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        label: state.layout.layout_tabs[layoutTab][widgetInViewIndex[layoutTab]],
        tjtype: 'widget',
        layoutPos: layoutTab,
        current_thought: state.current_thought,
      });
    }

  });
  return listOfWidgesNodes;
}

function thoughtMapUpdationFlow({ state, commit, getters }, lastSelectedEntity, entityObj) {

  const nodes = getters.getCurrentEntityPositionInThoughtMap === -1 ? [
    {
      id: generateUniqueIdForThoughtObject(entityObj),
      label: entityObj.label,
      type: 'modelRect',
      tjtype: 'entity',
      thoughttype: entityObj.type,
      size: [150, 50],
      style: {
        fill: '#010148',
        stroke: '#010148',
      },
      stateIcon: {
        show: false,
      },
    },
    ...listOfWidgetsInViewNodes(state),
  ] : [...listOfWidgetsInViewNodes(state)];
  const edges = [
    ...listOfWidgetsInViewNodes(state).map((node) => {
      return {
        source: generateUniqueIdForThoughtObject(entityObj),
        target: node.id
      }
    }),
  ];
  console.log({ lastSelectedEntity, nodes: state.nav_data.nodes });
  if (!!lastSelectedEntity && state.nav_data.nodes && state.nav_data.nodes.length > 0) {
    edges.push({
      source: generateUniqueIdForThoughtObject(lastSelectedEntity),
      target: generateUniqueIdForThoughtObject(entityObj),
    });
  }
  console.log(nodes, edges);
  commit('UPDATE_NAV_GRAPH', { nodes, edges });
  commit('SET_LAST_THOUGHT', { ...entityObj });

};

function generateUniqueIdForThoughtObject(thoughtObj) {
  return thoughtObj.type + thoughtObj.label;
}
